import React from "react";
import { Grid2 } from "@mui/material";
import PageTitle from "../../../components/Common/PageTitle/index";
import ContentCard from "../../../components/Content/ContentCard/index";
import IIH_TRAINING_ICON from "../../../assets/images/iih-training.png";

import { FooterText } from "../../../components/Common/FooterText";
import { RootBox, GridContainer, LearnMoreText } from "./Training.styles";
import {
  PAGE_TITLE,
  PAGE_INTRO_TEXT,
  LEARN_MORE_TEXT,
  FOOTER_TEXT,
  TRAINING_LEVEL_DATA,
} from "./Training.constants";

const Training = () => (
  <RootBox>
    <PageTitle
      title={PAGE_TITLE}
      text={PAGE_INTRO_TEXT}
      icon={IIH_TRAINING_ICON}
    />

    <GridContainer container spacing={2}>
      {TRAINING_LEVEL_DATA.map((item, index) => (
        <React.Fragment key={item.id}>
          <Grid2 item size={{ sm: 12, md: 6 }}>
            <ContentCard
              item={item}
              clickable={item.link}
              onClick={() => window.open(item.link, "_blank")}
              height={item.height || "200px"}
            />
          </Grid2>

          {index === 2 && (
            <Grid2 item size={{ xs: 12 }}>
              <LearnMoreText>{LEARN_MORE_TEXT}</LearnMoreText>
            </Grid2>
          )}
        </React.Fragment>
      ))}
    </GridContainer>

    <FooterText>{FOOTER_TEXT}</FooterText>
  </RootBox>
);

export default Training;
